module.exports = __webpack_public_path__ + "static/img/ArticlePresse001.09a08d6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ArticlePresse001.jpg
// module id = GTMY
// module chunks = 1